import React from 'react';
import { Button, Space } from 'antd';
import { translations, setLocale } from '../utils/translations';

/**
 * Header language switcher: EN | 日本語, same pattern as Solo video dashboard.
 * Clicking the active locale does nothing; clicking the other switches and re-renders.
 */
const LanguageSwitcher = ({ currentLocale, onLocaleChange }) => {
  const supported = translations.supportedLanguages || [
    { key: 'en', name: 'EN' },
    { key: 'ja', name: '日本語' },
  ];

  const handleSwitch = async (key) => {
    if (key === currentLocale) return;
    await setLocale(key);
    onLocaleChange(key);
  };

  return (
    <Space size="small" className="language-switcher">
      {supported.map(({ key, name }) => (
        <Button
          key={key}
          type={currentLocale === key ? 'primary' : 'default'}
          size="small"
          onClick={() => handleSwitch(key)}
        >
          {name}
        </Button>
      ))}
    </Space>
  );
};

export default LanguageSwitcher;
